module.exports = Backbone.Model.extend({
    connect: true,
    silentChange: false,
    selectors: ['membershipDiscount'],
    defaults: {
        membershipDiscount: {},
    },
});
